export const getErrorMessage = (e: any) => e?.response?.statusText || e?.message
